import { motion } from "motion/react";
import React from "react";

interface AnimatedBorderProps {
  children: React.ReactNode;
  className?: string;
  borderRadius?: number;
  borderWidth?: number;
  duration?: number;
}

export const AnimatedBorder = ({
  children,
  className = "",
  borderRadius = 12,
  borderWidth = 2,
  duration = 8,
}: AnimatedBorderProps) => {
  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{
        padding: borderWidth,
        borderRadius: borderRadius + borderWidth,
      }}
    >
      {/* Rotating Gradient Layer */}
      <div className="absolute inset-0 z-0 pointer-events-none flex items-center justify-center">
        <motion.div
          animate={{
            rotate: [0, 360],
          }}
          transition={{
            duration: duration,
            repeat: Infinity,
            ease: "linear",
          }}
          className="absolute w-[180%] h-[180%]"
          style={{
            background: "linear-gradient(80deg, #FFFFFF00 0%, #FFFFFF00 5%,#8466FD 71%, #0191F8 90%)",
            // filter: "blur(2px)",
          }}
        />
      </div>

      {/* Content Container */}
      <div
        className="relative z-10 size-full"
        style={{
          borderRadius: borderRadius,
        }}
      >
        {children}
      </div>
    </div>
  );
};
